.partnerModal {

}

.partnerModalHeader {

}

.partnerModalBody {

}

.partnerModalBodyRow {

}

.toast {

}

.toastHeader {

}

.toastBody {

}

.topButtons {
  margin-right: 5px;
}

.actionsRow {
  display: flex;
}

.actionButton {
  margin-right: 5px;
}

.partnersTable select,
.partnersTable input {
  margin-top: 5px;
  width: 100%;
}

.partnersTable {
  border-collapse: separate;
  border-spacing: 0;
}

.partnersTable th {
  position: sticky;
  top: 0;
  background-color: #fff;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  z-index: 1;
  white-space: nowrap;
  vertical-align: top !important;
}

.partnersTable td {
  border-right: 1px solid #dee2e6;
}

.partnersTable th:first-child,
.partnersTable td:first-child {
  /* Apply a left border on the first <td> or <th> in a row */
  border-left: 1px solid #dee2e6;
}

.partnersTable tr:last-child td {
  /* Apply a left border on the first <td> or <th> in a row */
  border-bottom: 1px solid #dee2e6;
}

.fullHeightTableContainer {
  display: flex;
  flex-direction: column;
}

.fitContentTableContainer {
  width: fit-content;
  overflow-y: auto;
}

.pagination {
  margin-top: 10px;
}

.pagination button {
  margin: 5px;
}

.sortButton {
  background: none !important;
  border: none;
}
.selectableRow {
  cursor: pointer;
}
